import { Store } from 'vuex';
import { PrecisePriceConfig, ValidatedConfig } from '@/entities/config';
import { ServiceContainer } from '@/services';

export class PrecisePriceCore {
	// eslint-disable-next-line no-useless-constructor
	constructor(private config: PrecisePriceConfig,
				private store: Store<void>,
				private services: ServiceContainer,
				private clientId: string) {
	}

	async init(): Promise<void> {
		this.store.coreModule.mutations.setClientId(this.clientId);
		this.loadConfig(this.config.getConfig());
		this.loadStyleVariables(this.config.getStyleVariables());
		this.generatePropertyStylesheet(this.store.coreModule.getters.styleVariables);
		this.watchStyleChanges();
		this.store.coreModule.actions.loadWebsiteSettings();
		// TODO: detect browser default language to set locale automatically
		// use core service to change locale:
		// await this.services.core.changeLocale(Locale.ES);
		// await this.services.core.loadLocale();
	}

	private generatePropertyStylesheet(styleVariables: StyleVariables) {
		const stylesElementId = 'precise-price-style-variables';

		let stylesEl: HTMLElement | null = document.getElementById(stylesElementId);

		if (!stylesEl) {
			stylesEl = document.createElement('style');

			stylesEl.id = stylesElementId;
			document.head.appendChild(stylesEl);
		}

		stylesEl.innerHTML = `:root {
			${Object.keys(styleVariables).map(variable => `${variable}: ${styleVariables[variable]}`).join(';')}
		}`;
	}

	private watchStyleChanges(): void {
		this.store.watch(
			() => this.store.coreModule.getters.styleVariables,
			newStyles => {
				this.generatePropertyStylesheet(newStyles);
			}
		);
	}

	private loadStyleVariables(styleVariables: StyleVariables): void {
		this.store.coreModule.mutations.loadStyleVariables(styleVariables);
	}

	private loadConfig(configObject: ValidatedConfig): void {
		this.store.coreModule.mutations.loadConfig(configObject);
	}
}
